import React, { useState, useEffect } from 'react';
import LandingPage from './components/LandingPage';
import { translations } from './content/translations';

function App() {
  const [language, setLanguage] = useState(() => {
    try {
      const saved = localStorage.getItem('dailyfit24-lang');
      if (saved === 'fi' || saved === 'en') return saved;
    } catch (_) {}
    return 'fi';
  });

  useEffect(() => {
    try {
      localStorage.setItem('dailyfit24-lang', language);
    } catch (_) {}
    document.documentElement.lang = language === 'fi' ? 'fi' : 'en';
    document.title = translations[language].metaTitle;
  }, [language]);

  return (
    <LandingPage language={language} onLanguageChange={setLanguage} />
  );
}

export default App;
